import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { dashApi } from "@/lib/dashApi";
import {
  EmptyState,
  ErrorState,
  LoadingState,
  PageHeader,
  Panel,
} from "@/components/dash/ui";

export default function EcosystemCoveragePage() {
  const q = useQuery({ queryKey: ["ecosystem-capabilities"], queryFn: dashApi.ecosystemCapabilities });
  const d = q.data;

  return (
    <div className="space-y-6">
      <PageHeader
        title="Ecosystem Coverage"
        description="What IRONDash reads from each BGR platform — implemented capabilities, and what was deliberately deferred or blocked (with reasons). All source access is read-only."
        right={
          d && (
            <span className="text-xs text-slate-500">
              {d.summary.implemented} implemented · {d.summary.deferred} deferred · {d.summary.blocked} blocked
            </span>
          )
        }
      />
      {q.isLoading ? (
        <LoadingState />
      ) : q.isError ? (
        <ErrorState error={q.error} />
      ) : !d ? (
        <EmptyState>No capability data.</EmptyState>
      ) : (
        <>
          <Panel title="Read-only guarantees">
            <ul className="list-disc space-y-1 pl-5 text-sm text-slate-300">
              {d.guarantees.map((g) => (
                <li key={g}>{g}</li>
              ))}
            </ul>
          </Panel>
          {d.systems.map((s) => (
            <Panel
              key={s.system}
              title={s.system}
              subtitle={`connector: ${s.connector}`}
              right={
                <Link to={s.page} className="text-xs text-sky-400 hover:text-sky-300">
                  Open page →
                </Link>
              }
            >
              <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
                <div>
                  <p className="mb-2 text-xs font-semibold uppercase tracking-wide text-emerald-300">
                    Implemented ({s.implemented.length})
                  </p>
                  <ul className="list-disc space-y-1 pl-5 text-sm text-slate-300">
                    {s.implemented.map((c) => (
                      <li key={c}>{c}</li>
                    ))}
                  </ul>
                </div>
                <div className="space-y-4">
                  {s.deferred.length > 0 && (
                    <div>
                      <p className="mb-2 text-xs font-semibold uppercase tracking-wide text-amber-300">
                        Deferred ({s.deferred.length})
                      </p>
                      <ul className="space-y-1 text-sm">
                        {s.deferred.map((c) => (
                          <li key={c.item} className="text-slate-300">
                            {c.item} <span className="text-xs text-slate-500">— {c.reason}</span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                  {s.blocked.length > 0 && (
                    <div>
                      <p className="mb-2 text-xs font-semibold uppercase tracking-wide text-rose-300">
                        Blocked ({s.blocked.length})
                      </p>
                      <ul className="space-y-1 text-sm">
                        {s.blocked.map((c) => (
                          <li key={c.item} className="text-slate-300">
                            {c.item} <span className="text-xs text-slate-500">— {c.reason}</span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>
              </div>
            </Panel>
          ))}
        </>
      )}
    </div>
  );
}
